import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomSnackbar from "../../../../components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../../../../utils/token";
import { Controller, useForm } from "react-hook-form";
import CustomTextFieldComp from "../../../../newComponent/customTextFieldComp";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function EditTrainerForm({ selectedData, branchId }) {
  const userId = localStorage.getItem("userId");
  const getTokenOrLogout = useGetTokenOrLogout();
  const [alltrainers, setAllTrainers] = useState([]);
  const [trainerName, setTrainerName] = useState(null);
  const [zoomLink,setZoomLink]=useState(selectedData?selectedData.zoom_link:null)
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
  const [isDemo, setIsDemo] = useState(
    selectedData?.is_demo === 0 ? false : true
  );
  const [selectedDay, setSelectedDay] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [daysList, setDaysList] = useState([]);
  const [changes, setChanges] = useState({});
  const [maximumDemo, setMaximumDemo] = useState(selectedData?.demo_capacity || null);
  const {control} = useForm();

  console.log("selectedData=",selectedData)
  const handleFieldChange = (fieldName, value) => {
    setChanges((prevChanges) => ({
      ...prevChanges,
      [fieldName]: value,
    }));
    // setValue(fieldName, value); // Update form value
  };

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  //fetch all trainers
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route/activetrainers/${branchId}`
        );
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          const defaultTrainer = sortedData.find(
            (trainer) => trainer.id === selectedData?.trainer_id?.id
          );
          setTrainerName(defaultTrainer);
          setAllTrainers(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleTrainerNameChange = (event, value) => {
    setTrainerName(value);
    handleFieldChange("trainer_id", value?.id);
  };

  // Fetch Upcomming Event
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}week`);
        if (response.ok) {
          const data = await response.json();

          setDaysList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // const handledaysChange = (e, dayId) => {
  //   if (e.target.checked) {
  //     if (dayId === "all") {
  //       const ids = daysList.map((i) => i.id);
  //       setSelectedDay(ids);
  //       handleFieldChange("day", ids);

  //     } else {
  //       setSelectedDay((prev) => [...new Set([...prev, dayId])]);
  //         handleFieldChange("day", ids);
  //     }
  //   } else {
  //     if (dayId === "all") {
  //       setSelectedDay([]);
  //        handleFieldChange("day", []);
  //     } else {
  //       setSelectedDay((prev) => prev.filter((id) => id !== dayId));
  //        handleFieldChange("day", []);
  //     }
  //   }
  // };

  // find selecteddays data

  const handledaysChange = (e, dayId) => {
    if (e.target.checked) {
      if (dayId === "all") {
        const ids = daysList.map((i) => i.id);
        setSelectedDay(ids);
        handleFieldChange("day", ids);
      } else {
        setSelectedDay((prev) => {
          const updated = [...new Set([...prev, dayId])];
          handleFieldChange("day", updated); // Call with updated value
          return updated;
        });
      }
    } else {
      if (dayId === "all") {
        setSelectedDay([]);
        handleFieldChange("day", []);
      } else {
        setSelectedDay((prev) => {
          const updated = prev.filter((id) => id !== dayId);
          handleFieldChange("day", updated); // Call with updated value
          return updated;
        });
      }
    }
  };

  useEffect(() => {
    if (selectedData?.day?.length > 0) {
      const selectedDays = selectedData?.day?.map((i) => i.id);
      setSelectedDay(selectedDays);
    }
  }, [selectedData]);

  console.log("selectedDay", selectedDay);
  // Helper to check if all are selected

  useEffect(() => {
    const allSelected =
      daysList?.length > 0 && selectedDay?.length === daysList?.length;
    setAllSelected(allSelected);
  }, [selectedDay, selectedData, daysList]);

  const handleClassDemoChange = (event) => {
    setMaximumDemo(null)
     handleFieldChange("demo_capacity", null);
    setIsDemo(event.target.checked); // converts string to boolean
    handleFieldChange("is_demo", event.target.checked);
  };

  const handlesubmit = async () => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    if (trainerName === null) {
      showSnackbar("Trainer name is required", "error");
      return;
    }

    if (selectedDay.length === 0) {
      showSnackbar("Please select class days", "error");
      return;
    }

    if (!maximumDemo && isDemo) {
      showSnackbar("Maximum demo capacity is required", "error");
      return;
    }

    const requestData = {
      ...changes,
      class_id: parseInt(selectedData?.id),
      user_id: parseInt(userId),
     
      // trainer_id: trainerName?.id,
      //  day: selectedDay,
      //   is_demo: isDemo,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}class/updatingtrainer/${selectedData?.id}`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();
     
      if (response.ok) {
        showSnackbar(result.message, "success");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
      } else {
        showSnackbar("Internal Server Error :", result.message, "error");
      }
    } catch (error) {
      showSnackbar("Internal Server Error :", "error");
    }
  };

const handleZoomLinkChange =(e)=>{
  setZoomLink(e.target.value)
  handleFieldChange("zoom_link",e.target.value)
}

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">
            Select Trainer{" "}
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <Autocomplete
            size="small"
            value={trainerName}
            onChange={handleTrainerNameChange}
            options={alltrainers}
            getOptionLabel={(option) =>
              `${option.first_name ? option.first_name : ""} ${
                option.last_name ? option.last_name : ""
              }`
            }
            renderInput={(params) => (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  style: { borderRadius: "10px" }, // Add borderRadius here
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">
            Select Days{" "}
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            justifyContent="center"
            border="1px solid rgba(0, 0, 0, 0.23)"
            flexWrap="wrap"
            borderRadius="10px"
          >
            <>
              <FormControlLabel
                sx={{
                  alignItems: "center", // Ensures vertical center alignment
                }}
                control={
                  <Checkbox
                    checked={allSelected}
                    sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
                    onClick={(e) => handledaysChange(e, "all")}
                  />
                }
                label={<Typography variant="h6">Every day</Typography>}
              />

              {daysList.map((day) => (
                <FormControlLabel
                  key={day.id}
                  sx={{ alignItems: "center" }}
                  control={
                    <Checkbox
                      checked={selectedDay?.includes(day.id)}
                      onChange={(e) => handledaysChange(e, day.id)}
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
                    />
                  }
                  label={
                    <Typography variant="h6">{day.week_short_name}</Typography>
                  }
                />
              ))}
            </>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} container alignItems="center">
          <Typography variant="h5">Enable demo for this class</Typography>
          <Checkbox
            sx={{ "& .MuiSvgIcon-root": { fontSize: 21 } }}
            checked={isDemo}
            onChange={handleClassDemoChange}
          />
        </Grid>

        {isDemo && (
          <Grid item xs={12} sm={6}>
            <Typography variant="h6">
              Maximum Demo Capacity{" "}
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>
            <TextField
              size="small"
              fullWidth
              value={maximumDemo}
              type="number"
              onChange={(e) => {
                setMaximumDemo(e.target.value);
                handleFieldChange("demo_capacity", e.target.value);
              }}
              InputProps={{ style: { borderRadius: "10px" } }}
            />
          </Grid>
        )}
        {/**this is added for zoom link */}
         {selectedData.mode_of_delivery=="online" && (<Grid item xs={12}>
                       <Typography variant="h6">Zoom Link </Typography>
            
                   
                           <CustomTextFieldComp
                             size="normal"
                         value={zoomLink}
onChange={handleZoomLinkChange}
                            
                             InputProps={{
                               style: { borderRadius: "10px" },
                             }}
                             fullWidth
                           />
                        
                       
                     </Grid>)}  
           

        <Grid item xs={12} textAlign="end">
          <Button
            onClick={handlesubmit}
            variant="contained"
            color="secondary"
            size="small"
          >
            Submit
          </Button>
        </Grid>

        
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
